import styled, { css } from 'styled-components';
import { currencyTokens } from '../../tokens/components/Currency/tokens';

/* @internal */
export const StyledCurrency = styled.span`
  padding-left: 0.1em;
  white-space: nowrap;

  ${({ theme }) =>
    (theme.loss || theme.negative) &&
    css`
      color: ${currencyTokens.FontColorLossDefault};
    `}

  ${({ theme }) =>
    (theme.gain || theme.positive) &&
    css`
      color: ${currencyTokens.FontColorGainDefault};
    `}

  ${({ theme }) =>
    (theme.zero || theme.undefined) &&
    css`
      color: inherit;
    `}
`;

export const CurrencyDirectionSymbol = styled.span`
  padding-right: 0.5em;
`;

export const CurrencyMinusSign = styled.span`
  font-weight: ${currencyTokens.FontWeightBaseDefault};
  padding-right: 0.1em;
`;

export const CurrencySymbolPre = styled.span`
  padding-right: 0.1em;
`;

export const CurrencySymbolPost = styled.span``;

export const CurrencyParenthesesPre = styled.span`
  padding-left: 0.2em;
  padding-right: 0.25em;
`;

export const CurrencyParenthesesPost = styled.span`
  padding-left: 0.25em;
  padding-right: 0.12em;
`;

export const CurrencyValue = styled.span``;
